(function () {
  document.querySelectorAll(".faq-q").forEach(function (q) {
    q.addEventListener("click", function () { q.setAttribute("aria-expanded", q.getAttribute("aria-expanded") !== "true"); });
  });
  var links = document.querySelectorAll(".faq-nav a");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) links.forEach(function (l) { l.classList.toggle("is-on", l.getAttribute("href") === "#" + e.target.id); }); }); }, { rootMargin: "-40% 0px -55% 0px" });
    document.querySelectorAll(".faq-group").forEach(function (g) { io.observe(g); });
  }
})();